import React, { forwardRef, useId } from 'react';

interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  helperText?: string;
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    const generatedId = useId();
    const id = props.id || generatedId;
    const inputClasses = `input-field ${error ? 'input-error' : ''} ${className}`;

    return (
      <div className="field-group">
        <label htmlFor={id} className="form-label">
          {label}
          {props.required && <span className="form-label-required">*</span>}
        </label>

        <input
          ref={ref}
          id={id}
          className={`${inputClasses} focus-visible`}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
          {...props}
        />

        {error && <p id={`${id}-error`} className="error-message">{error}</p>}

        {!error && helperText && <p className="helper-text">{helperText}</p>}
      </div>
    );
  }
);

TextField.displayName = 'TextField';